module.exports = __webpack_public_path__ + "static/media/feature-gift-code2.3191adf9.png";